import { render } from "./BackToTop.vue?vue&type=template&id=7fed9da6&ts=true"
import script from "./BackToTop.vue?vue&type=script&lang=ts"
export * from "./BackToTop.vue?vue&type=script&lang=ts"

import "./BackToTop.vue?vue&type=style&index=0&id=7fed9da6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__